/**
 * MenuContent is a immediate child of Menu component sibling to MenuLabel.
 * Clicking MenuLabel toggles visibility of MenuContent.
 */
import { Box } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

import MenuItem from '../MenuItem/MenuItem';

const rootSx = (theme) => ({
  position: 'absolute',
  zIndex: theme.tokens.zIndexPopup,

  backgroundColor: theme.tokens.matterColorLight,
  borderTop: `1px solid ${theme.tokens.matterColorNegative}`,
  boxShadow: theme.tokens.boxShadowPopup,
  borderRadius: '0 0 2px 2px',
  transition: theme.tokens.transitionStyleButton,
});

const openSx = {
  visibility: 'visible',
  opacity: 1,
  pointerEvents: 'auto',
};

const closedSx = {
  visibility: 'hidden',
  opacity: 0,
  pointerEvents: 'none',
};

const contentBaseSx = {
  display: 'flex',
  flexDirection: 'column',
  margin: 0,
};

const arrowBaseSx = {
  content: "' '",
  position: 'absolute',
  bottom: '100%',
  height: 0,
  width: 0,
  border: 'solid transparent',
  pointerEvents: 'none',
};

const arrowTopSx = (theme) => ({
  ...arrowBaseSx,
  borderBottomColor: theme.tokens.matterColorLight,
  borderWidth: '7px',
  marginLeft: '-7px',
});

const arrowBelowSx = (theme) => ({
  ...arrowBaseSx,
  borderBottomColor: theme.tokens.matterColorNegative,
  borderWidth: '9px',
  marginLeft: '-9px',
});

const MenuContent = ({
    arrowPosition = null,
    children,
    className = null,
    contentClassName = null,
    contentRef = null,
    contentSx = null,
    isOpen = false,
    rootClassName = '',
    style = null,
    sx = null,
  }) => {


  const stateSx = isOpen ? openSx : closedSx;
  const rootSxProp = rootClassName
    ? stateSx
    : (theme) => ({ ...rootSx(theme), ...stateSx });

  const arrowPositionStyle =
    arrowPosition && style.right != null
      ? { position: 'absolute', right: arrowPosition, top: 0 }
      : { position: 'absolute', left: arrowPosition, top: 0 };

  const arrow = arrowPosition ? (
    <div style={arrowPositionStyle}>
      <Box sx={arrowBelowSx} />
      <Box sx={arrowTopSx} />
    </div>
  ) : null;

  React.Children.forEach(children, (child) => {
    if (child !== null) {
      if (child.type !== MenuItem && child.type !== React.Fragment) {
        throw new Error('All children of MenuContent must be MenuItems.');
      }
    }
    // if (child.key == null) {
    //   throw new Error('All children of MenuContent must have a "key" prop.');
    // }
  });

  return (
    <Box className={classNames(rootClassName, className)} ref={contentRef} style={style} sx={[rootSxProp, sx].filter(Boolean)}>
      {arrow}
      <Box
        className={contentClassName || undefined}
        component="ul"
        sx={[contentClassName ? undefined : contentBaseSx, contentSx].filter(Boolean)}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MenuContent;
